import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=b87f06dc&"
import script from "./TableComponent.vue?vue&type=script&lang=js&"
export * from "./TableComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=b87f06dc&prod&lang=css&"
import style1 from "./TableComponent.vue?vue&type=style&index=1&id=b87f06dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports